import React from 'react'
import timelineImg from 'assets/images/timeline.png'

const publicUrl = process.env.REACT_APP_PUBLIC_URL;
const Timeline = props => {
  return (
    <div className='timeline absolute top-0 bg-repeat left-1/2 h-full' style={{
        backgroundImage: `url(${timelineImg})`,
        width: '3px',
    }}>
    </div>
  )
}

export default Timeline